var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-row",
    { staticClass: "ik-list-pagination", attrs: { gutter: 0 } },
    [
      _c(
        "el-col",
        { staticClass: "ik-list-pagination-group", attrs: { span: 24 } },
        [
          _c("el-pagination", {
            staticClass: "pagination",
            attrs: {
              "current-page": _vm.pageNoValue,
              "page-sizes": [5, 10, 20, 50, 100],
              "page-size": _vm.pageSizeValue,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.totalCount,
              "hide-on-single-page": false,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }